export const childConstants = {
    START: 'child:start',
    STOP: 'child:stop',
    CHILD: 'child:child',
    ADD: 'child:add',
    UPDATE: 'child:update',
    REMOVE: 'child:delete',
    CLEAR: 'child:clear',
};
